import { Inject, inject, Injectable, Optional } from '@angular/core';
import { MAT_DATE_LOCALE, NativeDateAdapter } from '@angular/material/core';
import { TranslateService } from '@ngx-translate/core';
import { formatDate } from '@angular/common';

@Injectable()
export class RsNativeDateAdapter extends NativeDateAdapter {
  private readonly translateService = inject(TranslateService);

  constructor(@Optional() @Inject(MAT_DATE_LOCALE) matDateLocale: string) {
    super(matDateLocale);
    this.setLocale(this.translateService.getCurrentLang() ?? this.translateService.getFallbackLang() ?? 'en');
    this.translateService.onLangChange.subscribe((event) => {
      this.setLocale(event.lang);
    });
  }

  /**
   * Override to format dates using the app's selected locale (not browser locale)
   */
  public override format(date: Date, displayFormat: unknown): string {
    const local = String(this.locale);
    if (displayFormat === 'input' || displayFormat === 'l') {
      return formatDate(date, 'shortDate', local) ?? '';
    } else {
      return formatDate(date, 'MMM yyyy', local) ?? '';
    }
  }

  /**
   * Override to ensure API-friendly ISO string format
   */
  public override toIso8601(date: Date): string {
    // Return clean ISO string that will serialize properly for API calls
    const isoString = date.toISOString();
    return isoString.substring(0, 10); // YYYY-MM-DD format
  }
}
